import Vue from "vue"
import api from '@/api';
import sysInit from './sysInit'
import store_sv from './store_sv'
import phone from './phone'
import AzureSpeech from '../../utils/azure-speech.js';
import { values, keys, uniq, reverse, sortBy, toPairs } from 'lodash'
import redmine from './redmine'
import moment from 'moment';
const reHesitation = /%HESITATION ?/g; // http://www.ibm.com/watson/developercloud/doc/speech-to-text/output.shtml#hesitation - D_ is handled below
const reRepeatedCharacter = /([a-z])\1{2,}/ig; // detect the same character repeated three or more times and remove it
const reDUnderscoreWords = /D_[^\s]+/g; // replace D_(an// ything)
const reHalfCharacter = new RegExp('[\uFF66-\uFF9F]', 'g')
const space = / /g;
var leftStream = '';
var rightStream = '';
var localAudioTrack = null;
var remoteAudioTrack = null;
let localAudioStream = null;
let remoteAudioStream = null;
let leftFlag = false;
let rightFlag = false;
var language_model = '';
var ws = null;
var wsUrl = null;
var lockReconnect = false;
var mode = '';
var leftUuid='';
var rightUuid='';
let firstRightSttConnect=false
let firstLeftSttConnect = false
let sttDelay = false
// var i = 0 ;
const state = {
  sttNotes: [],
  user: '',
  isMicOn: false,
  isMicPause: false,
  keywords: {},
  keywordCategory: {},

  manualChatKeyWordsObj: {},
  // isReStartFlag: false,

  //
  // sttStartTime: '',
  // sttEndTime: '',
  // startTime: '',
  // endTime: '',
  // telTime: '',

  stopStatus: "info",
  scrollStatus: "info",
  isScroll: false,
  isMouse: false,
  chat_empty_text_status: "",
  scrollFlag: true,
  isDisabl: false,
  dialogVisible: false,
  dialogVisible2: false,
  sttStartTime: "",
  sttEndTime: "",
  startTime: "",
  endTime: "",
  telTime: "",
  title: "",
  // 浏览器表示用
  sttNotesCopy: "",
  // Redmine保存用。和sttNotesCopy的区别在于sttNotesSave中图片URL的两侧添加了叹号，以符合Redmine中图片的富文本格式
  sttNotesSave: "",
  stream:"",
  recordAudioFlg:true,

  wordList: [],
  navigationTxtShow: false
}
const getters = {
  getSttNotes(state) { return state.sttNotes },
  getMicStatus(state) {
    return {
      isMicOn: state.isMicOn,
      isMicPause: state.isMicPause
    }
  },

}
const actions = {
  firstSttSupport(context,item){
    if (
      sysInit.state.talkStatus === "start" &&
      sysInit.state.ws_mode === "NEXMO_ASTERISK_PBX_MODE"
    ) {
      // this.dialogTableVisible = true;
      sttDelay = item.sttDelay
      firstRightSttConnect = true;
      firstLeftSttConnect = true;
      store_sv.state.phone_sv_help_status = 'iscalling'
      context.dispatch("sysInit/changerTurnMicStartTitle",sysInit.state.ws_mode,{ root: true });
      // this.$refs.turnMicStart.$el.click();
      state.sttStartTime = moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss");
      state.startTime = moment(state.sttStartTime).format("HH:mm:ss");
      context.dispatch("turnMicStart");
      // this.$store.commit("sysInit/changeNavigationText", "AIアシスタントが起動されました");
      context.commit("sysInit/changeNavigationText",sysInit.state.html_const.cons_237_footer_start_button,{ root: true });
      state.stopStatus = "danger";
      state.scrollStatus = "danger";
      state.isScroll = true;
      state.isMouse = true;
      // 通話開始ボタンが押下されたら、ステータスを通話中と設定
      sysInit.state.status = "BUSY";
      let modeFlag = true;
      context.commit("sysInit/changeSysConfig", { modeFlag, modeFlag },{ root: true });
    } else {
      state.sttStartTime = moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss");
      state.startTime = moment(state.sttStartTime).format("HH:mm:ss");
      state.isDisabl = false;
      // this.btn_type = "primary";
      context.dispatch("turnMicStart");
      context.dispatch("sysInit/changerTurnMicStartTitle",sysInit.state.ws_mode,{root: true});
      context.commit("sysInit/changeNavigationText",
      sysInit.state.html_const.cons_237_footer_start_button,{root: true}
      );
      state.stopStatus = "danger";
      state.scrollStatus = "danger";
      state.isScroll = true;
      state.isMouse = true;
      // 通話開始ボタンが押下されたら、ステータスを通話中と設定
      sysInit.state.status = "BUSY";
    }
      sysInit.state.piDiaLogVisible = false;
  },
  startSttForCall(conext ,item){
    Vue.prototype.$SIP.startSttForCall(phone.state.currentCallerNum)
  },
  setSttEndTime() {
    state.sttEndTime = moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss");
  },
  async handleAudioStream(context,item){
    let current = Date.now();
    let expiration = sysInit.state.sttConfig.expiration * 1000;
    console.log("before sttConfig:", sysInit.state.sttConfig)
    if (expiration - current <= 3000000) {
      await context.dispatch("sysInit/getSttToken", null, { root: true })
    }
    // await context.dispatch("sysInit/getSttToken", null, { root: true })
    state.user = sysInit.state.user_role == 'supervisor' ? sysInit.state.html_const.cons_218_supervisitor : sysInit.state.html_const.cons_216_operator;
    // state.user = sysInit.state.html_const.cons_216_operator;
    context.commit('changeMicStatus', { isMicOn: true, isMicPause: false });
    let leftFlag = false;
    let rightFlag = false;
    let tempSttNotes = state.sttNotes;
    // let audioStream = new MediaStream()
    // audioStream.addTrack(item.audioTrack)
    // console.log('entering handleAudioStream....', item, audioStream)
    // sysInit.state.sttConfig['mediaStream'] = item.mediaStream
    if(item.type=='local'){
      localAudioTrack = item.audioTrack
      localAudioStream = new MediaStream();
      localAudioStream.addTrack(item.audioTrack)
    }else{
      remoteAudioTrack = item.audioTrack
      remoteAudioStream = new MediaStream()
      remoteAudioStream.addTrack(item.audioTrack)
    }
    // console.log("current sttConfig:", sysInit.state.sttConfig)
    let config={
      subscriptionKey: sysInit.state.sttConfig.subscriptionKey,
      region: sysInit.state.sttConfig.region,
      endpointId: sysInit.state.sttConfig.endpointId,
      continuous: true,
      inactivityTimeout: -1,
      keepMicrophone:false,
      timestamps:true,
      mediaStream: item.type=='local'? localAudioStream : remoteAudioStream,
      interimResults:true,
      lowLatency:true,
    }
    if(item.type=='local'){
      let num = 0 
      function connectLeftSTT(){
        num++
        console.log(num);
        leftStream = AzureSpeech.SpeechToText.recognizeMicrophone(config);
        leftStream.recognizeStream
        //handleLeftMessage(context,{ sent: false, frame, json })
        .on('message', (frame, json) =>  handleLeftMessage({ sent: false, frame, json }));
        console.log('leftStream', leftStream);
        // leftStream.promise() // Once all data has been processed...
        // .then(function () {
        //   console.log('Left STT 识别完成');
        //   // context.dispatch("turnMicPause");
        // })
        // .catch(function (err) {
        //   num == 5 ? (context.dispatch("turnMicPause"), Vue.prototype.$message.error('STTサービスを接続できません。'))  : connectLeftSTT();
        // });
      }
      if(firstLeftSttConnect && sttDelay){
        setTimeout(()=>{
          connectLeftSTT()
        },phone.state.CALL_START_AUDIO_TIME)
        firstLeftSttConnect = false;
      }else{
        connectLeftSTT()
      }
    }else{
      let num = 0 
      function connectRightSTT(){
        num++
        rightStream = AzureSpeech.SpeechToText.recognizeMicrophone(config);
        rightStream.recognizeStream
        .on('message', (frame, json) => handleRightMessage({ sent: false, frame, json }));
        // rightStream.promise() // Once all data has been processed...
        // .then(function () {
        //   // context.dispatch("turnMicPause");
        // })
        // .catch(function (err) {
        //   num == 5 ? (context.dispatch("turnMicPause"), Vue.prototype.$message.error('STTサービスを接続できません。')) : connectRightSTT()
        // });
      }
      if(firstRightSttConnect && sttDelay){
        setTimeout(()=>{
          connectRightSTT()
        },phone.state.CALL_START_AUDIO_TIME)
        firstRightSttConnect = false;
      }else{
        connectRightSTT()
      }
    }
    async function handleRightMessage(msg) {
      // console.log('right' + msg.json.results);
      if (msg.json.results && msg.json.results.length > 0) {
        // let userStr = 'お問い合わせ者';
        let userStr = sysInit.state.html_const.cons_217_questioner;
        let text = msg.json.results[0].alternatives[0].transcript;
        // add for STT TOOL
        // let text =''
        // let sttResult = await handleSttMessages(msg,rightUuid)
        // if(sttResult.res){
        //   text = sttResult.res.data.replaceAll(reHalfCharacter, "")
        //   rightUuid = sttResult.res.uuid
        // }
        // Azure STT は ja-JP 固定 → 常に ja-JP 用後処理を適用
        text = text.replace(reHesitation, '')
          .replace(reRepeatedCharacter, '')
          .replace(reDUnderscoreWords, '')
          .replace(space, '');

        if (text.trim()) {
          let item = {
            user: userStr,
            text: text.trim().replace(/\n$/g,''),
            checked: false,
            isFinal: false,
            flag: 'right',
            status: false,
            username:sysInit.state.phone_questioner_name,
            messageTime: moment().tz("Asia/Tokyo").format("YYYY/MM/DD HH:mm")
          };
          if (!sysInit.state.showImmediately) {
            if (msg.json.results[0].final) {
              item.isFinal = true;
              item.id = tempSttNotes.length;
              tempSttNotes.push(item);
              context.commit('changeSttNotes', tempSttNotes);
              // context.dispatch("fetchKeywordByDialog", item);
              context.dispatch("fetchKeywordByDialog", {
                ...item,
                request_id: redmine.state.issue_id,
                keywordRate: sysInit.state.keywordRate
              });
              context.dispatch("redmine/updateHis", {}, { root: true });
            }
          }
          else {
            if (msg.json.results[0].final) {
              //update the last unfinished word into finished
              if (rightFlag) {
                for (let i = tempSttNotes.length - 1; i >= 0; i--) {
                  if (tempSttNotes[i].flag === 'right') {
                    item.isFinal = true;
                    tempSttNotes[i] = item;
                    tempSttNotes[i].id = i + 1;
                    break;
                  }
                }
              }
              // sttNotes = tempSttNotes;
              rightFlag = false;
              context.commit('changeSttNotes', tempSttNotes);
              // context.dispatch("fetchKeywordByDialog", item);
              context.dispatch("fetchKeywordByDialog", {
                ...item,
                request_id: redmine.state.issue_id,
                keywordRate: sysInit.state.keywordRate,

              });
              context.dispatch("redmine/updateHis", {}, { root: true });
            }
            else {
              //find last unfinished & update
              if (rightFlag) {
                for (let j = tempSttNotes.length - 1; j >= 0; j--) {
                  if (tempSttNotes[j].flag === 'right') {
                    tempSttNotes[j] = item;
                    tempSttNotes[j].id = j + 1;
                    break;
                  }
                }
              }
              else {
                //add first word in list
                tempSttNotes.push(item);
              }
              // sttNotes = tempSttNotes;
              rightFlag = true;
              context.commit('changeSttNotes', tempSttNotes);
            }
          }
        }
      }
    }
    async function handleLeftMessage(msg) {
      // console.log('stt start', moment().format('MMMM Do YYYY, hh:mm:ss'));
      state.chat_empty_text_status = msg.json.state;
      if (msg.json.error == 'Session timed out.') {
        state.chat_empty_text_status = "timed_out"
      }
      // console.log('chat_empty_text_status ',state.chat_empty_text_status);
      if (msg.json.results && msg.json.results.length > 0) {
        // let userStr = 'オペレーター';
        // let userStr = sysInit.state.html_const.cons_216_operator;
        let text = msg.json.results[0].alternatives[0].transcript;
        // add for STT TOOL
        // let text =''
        // let sttResult = await handleSttMessages(msg,leftUuid)
        // if(sttResult.res){
        //   text = sttResult.res.data.replaceAll(reHalfCharacter, "")
        //   leftUuid = sttResult.res.uuid
        // }
        // Azure STT は ja-JP 固定 → 常に ja-JP 用後処理を適用
        text = text.replace(reHesitation, '')
          .replace(reRepeatedCharacter, '')
          .replace(reDUnderscoreWords, '')
          .replace(space, '');

        // let text = msg.json.results[0].alternatives[0].transcript
        //   .replace(reHesitation, '')
        //   .replace(reRepeatedCharacter, '')
        //   .replace(reDUnderscoreWords, '')
        //   .replace(space, '');
        // console.log('msg.json.results[0].final',msg.json.results[0].final);
        // console.log('text',text);
        // console.log('leftFlag',leftFlag);
        if (text.trim()) {
          let item = {};
          if(sysInit.state.personalSingleMode == sysInit.mode.standMic){
             item = {
              user: state.user,
              text: text.trim().replace(/\n$/g,''),
              checked: false,
              isFinal: false,
              flag: 'left',
              status: false,
              username:sysInit.state.html_const.cons_266_moppy_name,
              messageTime: moment().tz("Asia/Tokyo").format("YYYY/MM/DD HH:mm"),
            };
          }else{
            item = {
              user: state.user,
              text: text.trim().replace(/\n$/g,''),
              checked: false,
              isFinal: false,
              flag: 'left',
              status: false,
              username: sysInit.state.user_name,
              messageTime: moment().tz("Asia/Tokyo").format("YYYY/MM/DD HH:mm"),
            };
          }

          // console.log('sysInit.state.showImmediately', sysInit.state.showImmediately)
          if (!sysInit.state.showImmediately) {
            if (msg.json.results[0].final) {
              item.isFinal = true;
              item.id = tempSttNotes.length;
              tempSttNotes.push(item);

              context.commit('changeSttNotes', tempSttNotes);
              context.dispatch("fetchKeywordByDialog", {
                ...item,
                request_id: redmine.state.issue_id,
                keywordRate: sysInit.state.keywordRate
              });

              context.dispatch("redmine/updateHis", {}, { root: true });
            }
          }
          else {
            if (msg.json.results[0].final) {
              //update the last unfinished word into finished
              if (leftFlag) {
                for (let i = tempSttNotes.length - 1; i >= 0; i--) {
                  if (tempSttNotes[i].flag === 'left') {
                    item.isFinal = true;
                    tempSttNotes[i] = item;
                    tempSttNotes[i].id = i + 1;
                    break;
                  }
                }
              }
              // sttNotes = tempSttNotes;
              leftFlag = false;
              context.commit('changeSttNotes', tempSttNotes);
              // context.dispatch("fetchKeywordByDialog", item);
              context.dispatch("fetchKeywordByDialog", {
                ...item,
                request_id: redmine.state.issue_id,
                keywordRate: sysInit.state.keywordRate
              });
              context.dispatch("redmine/updateHis", {}, { root: true });
            }
            else {
              //find last unfinished & update
              if (leftFlag) {
                for (let j = tempSttNotes.length - 1; j >= 0; j--) {
                  if (tempSttNotes[j].flag === 'left') {
                    tempSttNotes[j] = item;
                    tempSttNotes[j].id = j + 1;
                    break;
                  }
                }
              }
              else {
                //add first word in list
                tempSttNotes.push(item);
              }
              // sttNotes = tempSttNotes;
              leftFlag = true;
              context.commit('changeSttNotes', tempSttNotes);
            }
          }
        }
      }
      // console.log('stt end', moment().format('MMMM Do YYYY, hh:mm:ss'))
    };
    function handleSttMessages(msg,uuid){
      if (msg.json.results && msg.json.results.length > 0 ){
        let sttParams={
          has_time:false,
          stt_json:{
            results:msg.json.results
          }
        }
        if(msg.json.results[0].alternatives[0].hasOwnProperty('timestamps')){
          sttParams.has_time =true
        }
        if(uuid!=''){
          sttParams['uuid']=uuid
        }
        return new Promise((resolve, reject) => {
          api.callSttTool(sttParams).then((res)=>{
            // console.log('callSttTool',res)
            return resolve({ res: res.data, code: 0 });
          }).catch(err => {
            return reject({ code: -1, err: err })
          })
        })
      }
    }
  },
  async sttStart(context, item) {
    let current = Date.now();
    let expiration = sysInit.state.sttConfig.expiration * 1000;

    console.log("before sttConfig:", sysInit.state.sttConfig)

    if (expiration - current <= 3000000) {
      await context.dispatch("sysInit/getSttToken", null, { root: true })
    }
    // await context.dispatch("sysInit/getSttToken", null, { root: true })
    context.commit('changeMicStatus', { isMicOn: true, isMicPause: false });
    // let sttNotes = state.sttNotes;
    let leftFlag = false;
    let rightFlag = false;
    let tempSttNotes = state.sttNotes;
    leftUuid=''
    console.log('sysInit.state.config', sysInit.state.sttConfig)
    leftStream = AzureSpeech.SpeechToText.recognizeMicrophone(sysInit.state.sttConfig);
    leftStream.recognizeStream
      .on('message', (frame, json) => handleLeftMessage({ sent: false, frame, json }));
    leftStream.promise() // Once all data has been processed...
      .then(function () {
        context.dispatch("turnMicPause");
      })
      .catch(function (err) {
        context.dispatch("turnMicPause");
      });
    // state.user = sysInit.state.html_const.cons_216_operator;
    state.user = sysInit.state.user_role == 'supervisor' ? sysInit.state.html_const.cons_218_supervisitor : sysInit.state.html_const.cons_216_operator;

    // 2021-02-22
    if (sysInit.state.personalEnable == 0 && sysInit.state.systemSingleMode) {
      if (sysInit.state.systemSingleMode == sysInit.mode.asterisk) {
        // Azure STT は ja-JP 固定で endpointId が customization の役割を担う為、model/customization_id は不要
        wsUrl = sysInit.state.nexmo_websocket_uri + 'nexmo?sip=' + sysInit.state.tel_num
          + '&issue_id=' + redmine.state.issue_id;
      } else if (sysInit.state.systemSingleMode == sysInit.mode.converger) {
        sysInit.state.sttConfig.left = false;
        rightUuid =''
        rightStream = AzureSpeech.SpeechToText.recognizeMicrophone(sysInit.state.sttConfig);
        rightStream.recognizeStream
          .on('message', (frame, json) => handleRightMessage({ sent: false, frame, json }));
      } else if (sysInit.state.systemSingleMode == sysInit.mode.standMic) {
        state.user = sysInit.state.html_const.cons_254_watson;
        // state.username = sysInit.state.html_const.cons_266_moppy_name;
        sysInit.state.operator_logo = sysInit.state.watson_logo;
        api.updateStandMicIssueId({
          sip: sysInit.state.tel_num,
          issue_id: redmine.state.issue_id
        }).then((res) => {
        }, (err) => {
          console.log(err);
        });
      }
    } else if (sysInit.state.personalEnable == 1 && sysInit.state.personalSingleMode) {
      if (sysInit.state.personalSingleMode == sysInit.mode.asterisk) {
        // Azure STT は ja-JP 固定で endpointId が customization の役割を担う為、model/customization_id は不要
        wsUrl = sysInit.state.nexmo_websocket_uri + 'nexmo?sip=' + sysInit.state.tel_num
          + '&issue_id=' + redmine.state.issue_id;
      } else if (sysInit.state.personalSingleMode == sysInit.mode.standMic) {
        state.user = sysInit.state.html_const.cons_254_watson;
        // state.username = sysInit.state.html_const.cons_266_moppy_name;
        sysInit.state.operator_logo = sysInit.state.watson_logo;
        console.log('updateStandMicIssueId start', moment().format('MMMM Do YYYY, hh:mm:ss'))

        api.updateStandMicIssueId({
          sip: sysInit.state.tel_num,
          issue_id: redmine.state.issue_id
        }).then((res) => {
          console.log('updateStandMicIssueId end', moment().format('MMMM Do YYYY, hh:mm:ss'))
        }, (err) => {
          console.log(err);
        });
      }
    }
    if (wsUrl) {
      createWebSocket(wsUrl);
    }

    function createWebSocket(url) {
      try {
        if ('WebSocket' in window) {
          ws = new WebSocket(url);
        }
        initEventHandle();
      } catch (e) {
        reconnect(url);
        console.log("AICC websocket create err:", e);
      }
    }

    function initEventHandle() {
      ws.onclose = function (event) {
        reconnect(wsUrl);
        console.log("AICC websocket close event:", event);
      };
      ws.onerror = function (err) {
        reconnect(wsUrl);
        console.log("AICC websocket err:", err);
      };
      ws.onopen = function () {
        heartCheck.reset().start();
        console.log("AICC websocket open.");
      };
      ws.onmessage = function (event) {
        heartCheck.reset().start();
        if (event.data != 'pong') {
          let msg = {
            json: JSON.parse(event.data)
          }
          if (!state.isMicPause) {
            handleRightMessage(msg);
          }
        }
      };
    }

    function reconnect(url) {
      if (lockReconnect) return;
      lockReconnect = true;
      setTimeout(function () {
        createWebSocket(url);
        lockReconnect = false;
      }, 2000);
    }

    let heartCheck = {
      timeout: 1000,
      timeoutObj: null,
      serverTimeoutObj: null,
      reset: function () {
        clearTimeout(this.timeoutObj);
        clearTimeout(this.serverTimeoutObj);
        return this;
      },
      start: function () {
        let self = this;
        this.timeoutObj = setTimeout(function () {
          if (ws != null && ws.readyState == 1) {
            ws.send("ping");
          }
          self.serverTimeoutObj = setTimeout(function () {
            // if(ws != null && ws.readyState == 3){
            //   ws.send("stop");
            // }
          }, self.timeout)
        }, this.timeout)
      }
    }

    // window.onbeforeunload = function() {
    //   if(ws != null){
    //     ws.send("stop");
    //   }
    // }

    async function handleLeftMessage(msg) {
      // console.log('stt start', moment().format('MMMM Do YYYY, hh:mm:ss'));
      state.chat_empty_text_status = msg.json.state;
      if (msg.json.error == 'Session timed out.') {
        state.chat_empty_text_status = "timed_out"
      }
      // console.log('chat_empty_text_status ',state.chat_empty_text_status);
      if (msg.json.results && msg.json.results.length > 0) {
        // let userStr = 'オペレーター';
        // let userStr = sysInit.state.html_const.cons_216_operator;
        let text = msg.json.results[0].alternatives[0].transcript;
        // add for STT TOOL
        // let text =''
        // let sttResult = await handleSttMessages(msg,leftUuid)
        // if(sttResult.res){
        //   text = sttResult.res.data.replaceAll(reHalfCharacter, "")
        //   leftUuid = sttResult.res.uuid
        // }
        // Azure STT は ja-JP 固定 → 常に ja-JP 用後処理を適用
        text = text.replace(reHesitation, '')
          .replace(reRepeatedCharacter, '')
          .replace(reDUnderscoreWords, '')
          .replace(space, '');

        // let text = msg.json.results[0].alternatives[0].transcript
        //   .replace(reHesitation, '')
        //   .replace(reRepeatedCharacter, '')
        //   .replace(reDUnderscoreWords, '')
        //   .replace(space, '');
        // console.log('msg.json.results[0].final',msg.json.results[0].final);
        // console.log('text',text);
        // console.log('leftFlag',leftFlag);
        if (text.trim()) {
          let item = {};
          if(sysInit.state.personalSingleMode == sysInit.mode.standMic){
             item = {
              user: state.user,
              text: text.trim().replace(/\n$/g,''),
              checked: false,
              isFinal: false,
              flag: 'left',
              status: false,
              username:sysInit.state.html_const.cons_266_moppy_name,
              messageTime: moment().tz("Asia/Tokyo").format("YYYY/MM/DD HH:mm"),
            };
          }else{
            item = {
              user: state.user,
              text: text.trim().replace(/\n$/g,''),
              checked: false,
              isFinal: false,
              flag: 'left',
              status: false,
              username:sysInit.state.user_name,
              messageTime: moment().tz("Asia/Tokyo").format("YYYY/MM/DD HH:mm"),
            };
          }

          if (!sysInit.state.showImmediately) {
            if (msg.json.results[0].final) {
              item.isFinal = true;
              item.id = tempSttNotes.length;
              tempSttNotes.push(item);

              context.commit('changeSttNotes', tempSttNotes);
              context.dispatch("fetchKeywordByDialog", {
                ...item,
                request_id: redmine.state.issue_id,
                keywordRate: sysInit.state.keywordRate
              });

              context.dispatch("redmine/updateHis", {}, { root: true });
            }
          }
          else {
            if (msg.json.results[0].final) {
              //update the last unfinished word into finished
              if (leftFlag) {
                for (let i = tempSttNotes.length - 1; i >= 0; i--) {
                  if (tempSttNotes[i].flag === 'left') {
                    item.isFinal = true;
                    tempSttNotes[i] = item;
                    tempSttNotes[i].id = i + 1;
                    break;
                  }
                }
              }
              // sttNotes = tempSttNotes;
              leftFlag = false;
              context.commit('changeSttNotes', tempSttNotes);
              // context.dispatch("fetchKeywordByDialog", item);
              context.dispatch("fetchKeywordByDialog", {
                ...item,
                request_id: redmine.state.issue_id,
                keywordRate: sysInit.state.keywordRate
              });
              context.dispatch("redmine/updateHis", {}, { root: true });
            }
            else {
              //find last unfinished & update
              if (leftFlag) {
                for (let j = tempSttNotes.length - 1; j >= 0; j--) {
                  if (tempSttNotes[j].flag === 'left') {
                    tempSttNotes[j] = item;
                    tempSttNotes[j].id = j + 1;
                    break;
                  }
                }
              }
              else {
                //add first word in list
                tempSttNotes.push(item);
              }
              // sttNotes = tempSttNotes;
              leftFlag = true;
              context.commit('changeSttNotes', tempSttNotes);
            }
          }
        }
      }
      // console.log('stt end', moment().format('MMMM Do YYYY, hh:mm:ss'))
    };

    async function handleRightMessage(msg) {
      // console.log('right' + msg.json.results);
      if (msg.json.results && msg.json.results.length > 0) {
        // let userStr = 'お問い合わせ者';
        let userStr = sysInit.state.html_const.cons_217_questioner;
        let text = msg.json.results[0].alternatives[0].transcript;
        // add for STT TOOL
        // let text =''
        // let sttResult = await handleSttMessages(msg,rightUuid)
        // if(sttResult.res){
        //   text = sttResult.res.data.replaceAll(reHalfCharacter, "")
        //   rightUuid = sttResult.res.uuid
        // }
        // Azure STT は ja-JP 固定 → 常に ja-JP 用後処理を適用
        text = text.replace(reHesitation, '')
          .replace(reRepeatedCharacter, '')
          .replace(reDUnderscoreWords, '')
          .replace(space, '');

        // let text = msg.json.results[0].alternatives[0].transcript
        //   .replace(reHesitation, '')
        //   .replace(reRepeatedCharacter, '')
        //   .replace(reDUnderscoreWords, '')
        //   .replace(space, '');

        if (text.trim()) {
          let item = {
            user: userStr,
            text: text.trim().replace(/\n$/g,''),
            checked: false,
            isFinal: false,
            flag: 'right',
            status: false,
            username:sysInit.state.phone_questioner_name,
            messageTime: moment().tz("Asia/Tokyo").format("YYYY/MM/DD HH:mm"),
          };

          if (!sysInit.state.showImmediately) {
            if (msg.json.results[0].final) {
              item.isFinal = true;
              item.id = tempSttNotes.length;
              tempSttNotes.push(item);
              context.commit('changeSttNotes', tempSttNotes);
              // context.dispatch("fetchKeywordByDialog", item);
              context.dispatch("fetchKeywordByDialog", {
                ...item,
                request_id: redmine.state.issue_id,
                keywordRate: sysInit.state.keywordRate
              });
              context.dispatch("redmine/updateHis", {}, { root: true });
            }
          }
          else {
            if (msg.json.results[0].final) {
              //update the last unfinished word into finished
              if (rightFlag) {
                for (let i = tempSttNotes.length - 1; i >= 0; i--) {
                  if (tempSttNotes[i].flag === 'right') {
                    item.isFinal = true;
                    tempSttNotes[i] = item;
                    tempSttNotes[i].id = i + 1;
                    break;
                  }
                }
              }
              // sttNotes = tempSttNotes;
              rightFlag = false;
              context.commit('changeSttNotes', tempSttNotes);
              // context.dispatch("fetchKeywordByDialog", item);
              context.dispatch("fetchKeywordByDialog", {
                ...item,
                request_id: redmine.state.issue_id,
                keywordRate: sysInit.state.keywordRate,

              });
              context.dispatch("redmine/updateHis", {}, { root: true });
            }
            else {
              //find last unfinished & update
              if (rightFlag) {
                for (let j = tempSttNotes.length - 1; j >= 0; j--) {
                  if (tempSttNotes[j].flag === 'right') {
                    tempSttNotes[j] = item;
                    tempSttNotes[j].id = j + 1;
                    break;
                  }
                }
              }
              else {
                //add first word in list
                tempSttNotes.push(item);
              }
              // sttNotes = tempSttNotes;
              rightFlag = true;
              context.commit('changeSttNotes', tempSttNotes);
            }
          }
        }
      }
    }
    function handleSttMessages(msg,uuid){
      if (msg.json.results && msg.json.results.length > 0 ){
        let sttParams={
          has_time:false,
          stt_json:{
            results:msg.json.results
          }
        }
        if(msg.json.results[0].alternatives[0].hasOwnProperty('timestamps')){
          sttParams.has_time =true
        }
        if(uuid!=''){
          sttParams['uuid']=uuid
        }
        return new Promise((resolve, reject) => {
          api.callSttTool(sttParams).then((res)=>{
            // console.log('callSttTool',res)
            return resolve({ res: res.data, code: 0 });
          }).catch(err => {
            return reject({ code: -1, err: err })
          })
        })
      }
    }
  },
  turnMicOff(context, item) {
    try {
      console.log('enter.....turnMicOff')
      state.formattedMessages = state.sttNotes;
      leftStream.stop();

      // let stt_mode = '';
      // if (sysInit.state.personalEnable == 0 && sysInit.state.systemSingleMode) {
      //   if (sysInit.state.systemSingleMode == sysInit.mode.asterisk) {
      //     stt_mode = sysInit.mode.asterisk;
      //   } else if (sysInit.state.systemSingleMode == sysInit.mode.converger) {
      //     stt_mode = sysInit.mode.converger;
      //   } else if (sysInit.state.systemSingleMode == sysInit.mode.standMic) {
      //     stt_mode = sysInit.mode.standMic;
      //   }
      // } else if (sysInit.state.personalEnable == 1 && sysInit.state.personalSingleMode) {
      //   if (sysInit.state.personalSingleMode == sysInit.mode.asterisk) {
      //     stt_mode = sysInit.mode.asterisk;
      //   } else if (sysInit.state.personalSingleMode == sysInit.mode.standMic) {
      //     stt_mode = sysInit.mode.standMic;
      //   }
      // }

      if (sysInit.state.ws_mode && sysInit.state.ws_mode == sysInit.mode.converger) {
        rightStream.stop();
      }
      if (sysInit.state.ws_mode && sysInit.state.ws_mode == sysInit.mode.asterisk) {
        // if (ws != null && ws.readyState == 1) {
        //   ws.send("stop");
        // }
        rightStream.stop();
      }
      // state.isMicOn = false;
      // console.log(state.isMicOn);
      // context.dispatch("sysInit/changerTurnMicStartTitle",sysInit.state.ws_mode);
    } catch (e) {
      console.log(e);
    }
  },
  turnMicStart(context, item) {
    // let stt_mode = '';
    // if (sysInit.state.personalEnable == 0 && sysInit.state.systemSingleMode) {
    //   if (sysInit.state.systemSingleMode == sysInit.mode.asterisk) {
    //     stt_mode = sysInit.mode.asterisk;
    //   } else if (sysInit.state.systemSingleMode == sysInit.mode.converger) {
    //     stt_mode = sysInit.mode.converger;
    //   } else if (sysInit.state.systemSingleMode == sysInit.mode.standMic) {
    //     stt_mode = sysInit.mode.standMic;
    //   }
    // } else if (sysInit.state.personalEnable == 1 && sysInit.state.personalSingleMode) {
    //   if (sysInit.state.personalSingleMode == sysInit.mode.asterisk) {
    //     stt_mode = sysInit.mode.asterisk;
    //   } else if (sysInit.state.personalSingleMode == sysInit.mode.standMic) {
    //     stt_mode = sysInit.mode.standMic;
    //   }
    // }
    // context.commit('changeMicStatus', { isMicOn: true });
    // state.isReStartFlag = false;



    if (redmine.state.issue_id != null && sysInit.state.ws_mode === "NEXMO_ASTERISK_PBX_MODE" && sysInit.state.talkStatus === 'start') {
      // state.isReStartFlag = false;
      // context.commit('changeMicStatus', { isMicOn: true });
      // context.dispatch("sttStart");
      context.dispatch('startSttForCall')
      // context.dispatch("changeOnCallFlag");
    } else if (sysInit.state.ws_mode === 'STAND_MIC_MODE') {
      context.commit('changeMicStatus', { isMicOn: true });
      // state.isReStartFlag = false;
      console.log('createIssue start', moment().format('MMMM Do YYYY, hh:mm:ss'))
      context.dispatch("redmine/createIssue", {}, { root: true }).then(res => {
        sysInit.state.isBlingFlg_call = false;
        console.log('createIssue end', moment().format('MMMM Do YYYY, hh:mm:ss'))
        //
        context.dispatch("sttStart");//
      }).catch(err => {
        context.dispatch("sttStart");
      });
    }




  },
  turnMicEnd(context, item) {
    if (sysInit.state.ws_mode === "NEXMO_ASTERISK_PBX_MODE") {
      context.commit('changeMicStatus', { isMicOn: true, isMicPause: false });
    } else {
      context.commit('changeMicStatus', { isMicOn: false, isMicPause: false });
      context.dispatch("turnMicOff");
    }

  },
  turnMicPause(context, item) {
    context.commit('changeMicStatus', { isMicPause: true });
    if (sysInit.state.ws_mode === "NEXMO_ASTERISK_PBX_MODE") {
      // console.log('leftStream....',leftStream,leftStream.recognizeStream.options.mediaStream.getAudioTracks())
      removeAudioTrack()
      // console.log('leftStream R....',leftStream.recognizeStream)
      // let leftTrack = leftStream.recognizeStream.options.mediaStream.getAudioTracks()[0]
      // let rightTrack = rightStream.recognizeStream.options.mediaStream.getAudioTracks()[0]
      // let leftTrack = localAudioStream.getAudioTracks()[0]
      // let rightTrack = remoteAudioStream.getAudioTracks()[0]
      // console.log('track', leftTrack, rightTrack )
      // leftStream.recognizeStream.options.mediaStream.removeTrack(leftTrack)
      // rightStream.recognizeStream.options.mediaStream.removeTrack(rightTrack)
      // localAudioStream.removeTrack(leftTrack)
      // remoteAudioStream.removeTrack(rightTrack)
      // leftStream.recognizeStream.socket.close();
      // rightStream.recognizeStream.socket.close();
      // console.log('leftStream2....',leftStream.recognizeStream.options.mediaStream.getAudioTracks())
      // leftStream.recognizeStream.finish()
      // rightStream.recognizeStream.finish()
      context.dispatch("turnMicOff");
    }else{
      context.dispatch("turnMicOff");
    }
  },
  turnMicOn(context, item) {
    context.commit('changeMicStatus', { isMicPause: false });
    // state.isReStartFlag = true;
    if (sysInit.state.ws_mode === "NEXMO_ASTERISK_PBX_MODE" ) {
      console.log('startSttForCall.......')
      context.dispatch('startSttForCall')
    }else{
      context.dispatch("sttStart");
    }
  },
  fetchKeywordByDialog(context, item) {
    item.mode = sysInit.state.personalSingleMode;
    let keywords = state.keywords;
    let keywordCategory = state.keywordCategory;
    item.user_id = sysInit.state.login_id;
    // item.user_id = "ming.lu.fan.dl@ibm.com";
    api.getKeywordByDialog(item).then((res) => {
      if(JSON.stringify(res.data) !="{}"){
          if (res.data.code != 1001) {
            if (res.data.data.d3 != undefined) {
              context.dispatch("echart/echartInit", { type: 'map', data: res.data.data.d3 }, { root: true });
              context.dispatch("echart/echartInit", { type: 'minmap', data: res.data.data.d3 }, { root: true });
            }
            if (res.data.data.d3.nodes && res.data.data.d3.nodes.length > 0) {
              context.commit("discovery/changeMapData", res.data.data.d3, { root: true });
              context.commit("sysInit/changeCurrentKeyword", res.data.data.notesitem, { root: true });
            }

            if (sysInit.state.ws_mode === 'MANUAL_CHAT_MODE') {
              // let keywords = {};
              // let keywordCategory = {};
              // let tempId = sysInit.state.manualChatQuestionerId;
              let tempId = sysInit.state.manualChatModeIssueId;

              if (!state.manualChatKeyWordsObj.hasOwnProperty(tempId)) {

                state.manualChatKeyWordsObj[tempId] = {
                  keywords: {},
                  keywordCategory: {}
                }
              }
              console.log("state.manualChatKeyWordsObj111",state.manualChatKeyWordsObj)
              if (res.data.data.result.length > 0) {
                for (let entity of res.data.data.result) {
                  if (state.manualChatKeyWordsObj[tempId].keywords.hasOwnProperty(entity.value)) {
                    state.manualChatKeyWordsObj[tempId].keywords[entity.value] += 1;
                  } else {
                    state.manualChatKeyWordsObj[tempId].keywordCategory[entity.value] = entity.entity;
                    state.manualChatKeyWordsObj[tempId].keywords[entity.value] = 1;
                  }

                  console.log("state.manualChatKeyWordsObj",state.manualChatKeyWordsObj)


                }
              }
            } else {
              if (res.data.data.result.length > 0) {
                for (let entity of res.data.data.result) {
                  if (keywords.hasOwnProperty(entity.value)) {
                    keywords[entity.value] += 1;
                  } else {
                    keywordCategory[entity.value] = entity.entity;
                    keywords[entity.value] = 1;
                  }
                  context.commit('changeKeywords', { keywordCategory, keywords });

                  // console.log("state.keywords",state.keywords);
                  // console.log("state.keywordCategory",state.keywordCategory);
                }
              }
            }

            let txt = '';
            let origin_txt = '';
            let wow_txt = '';
            let origin_wow_txt = '';
            let warning_txt = '';
            let origin_warning_txt = '';
            let groupNgWord = {
              ng_user: [],
              ng_op: [],
              ng_manner: [],
              f2f_ng: [],
              f2f_ng_manner: [],
              wow_user: [],
              wow_op: [],
              wow_watson: [],
              warning_user: [],
              warning_op: [],
              warning_watson: []
            }
            let simpleNgWordStr = '';
            let originNgWordStr = '';
            let simpleNgWordMannerStr = '';
            let originNgWordMannerStr = '';
            let simpleWowWordStr = '';
            let originWowWordStr = '';
            let simpleWarningWordStr = '';
            let originWarningWordStr = '';
            // ng words
            if (res.data.data.ngWords && res.data.data.ngWords.length > 0) {
              for(let i = 0; i < res.data.data.ngWords.length; i++){
                if(res.data.data.ngWords[i]['user_flag'] == 'operator_ngmanner'){
                  groupNgWord['ng_manner'].push(res.data.data.ngWords[i]);
                } else if (res.data.data.ngWords[i]['user_flag'] == 'operator'){
                  groupNgWord['ng_op'].push(res.data.data.ngWords[i]);
                } else if (res.data.data.ngWords[i]['user_flag'] == 'questioner'){
                  groupNgWord['ng_user'].push(res.data.data.ngWords[i]);
                } else if (res.data.data.ngWords[i]['user_flag'] == 'watson_ngmanner'){
                  groupNgWord['f2f_ng_manner'].push(res.data.data.ngWords[i]);
                } else if (res.data.data.ngWords[i]['user_flag'] == 'watson_ng'){
                  groupNgWord['f2f_ng'].push(res.data.data.ngWords[i]);
                }
              }
              
              if(groupNgWord['f2f_ng'].length > 0 || groupNgWord['f2f_ng_manner'].length > 0){
                if(groupNgWord['f2f_ng'].length > 0){
                  let strObj = formatWordArr(groupNgWord['f2f_ng']);
                  originNgWordStr = strObj['origin'];
                  simpleNgWordStr = strObj['simple'];

                  txt = sysInit.state.html_const.cons_262_f2f_ng.replace('{params}', simpleNgWordStr);
                  origin_txt = sysInit.state.html_const.cons_262_f2f_ng.replace('{params}', originNgWordStr);
                }
                if(groupNgWord['f2f_ng_manner'].length > 0){
                  let strObj = formatWordArr(groupNgWord['f2f_ng_manner']);
                  originNgWordMannerStr = strObj['origin'];
                  simpleNgWordMannerStr = strObj['simple'];

                  if(txt.length > 0){
                    txt = txt + '、';
                    origin_txt = origin_txt + '、';
                  }
                  txt += sysInit.state.html_const.cons_263_f2f_ng_manner.replace('{params}', simpleNgWordMannerStr);
                  origin_txt += sysInit.state.html_const.cons_263_f2f_ng_manner.replace('{params}', originNgWordMannerStr);
                }
                console.log('f2f start push++++++',txt, origin_txt );
                state.wordList.push({origin: origin_txt, content: txt, type : 'ng', status: '0', keyword: simpleNgWordStr });
              }else{
                if(groupNgWord['ng_user'].length > 0 || groupNgWord['ng_op'].length > 0){
                  if(groupNgWord['ng_user'].length > 0){
                    let strObj = formatWordArr(groupNgWord['ng_user']);
                    originNgWordStr = strObj['origin'];
                    simpleNgWordStr = strObj['simple'];

                    txt = sysInit.state.html_const.cons_255_user_ng.replace('{params}', simpleNgWordStr);
                    origin_txt = sysInit.state.html_const.cons_255_user_ng.replace('{params}', originNgWordStr);
                  }else{
                    let strObj = formatWordArr(groupNgWord['ng_op']);
                    originNgWordStr = strObj['origin'];
                    simpleNgWordStr = strObj['simple'];

                    txt = sysInit.state.html_const.cons_256_operator_ng.replace('{params}', simpleNgWordStr);
                    origin_txt = sysInit.state.html_const.cons_256_operator_ng.replace('{params}', originNgWordStr);
                  }
                }
                if(groupNgWord['ng_manner'].length > 0){
                  let strObj = formatWordArr(groupNgWord['ng_manner']);
                  originNgWordMannerStr = strObj['origin'];
                  simpleNgWordMannerStr = strObj['simple'];

                  if(txt.length > 0){
                    txt = txt + '、';
                    origin_txt = origin_txt + '、';
                  }
                  txt += sysInit.state.html_const.cons_257_operator_manner.replace('{params}', simpleNgWordMannerStr);
                  origin_txt += sysInit.state.html_const.cons_257_operator_manner.replace('{params}', originNgWordMannerStr);
                }
                state.wordList.push({origin: origin_txt, content: txt, type : 'ng', status: '0', keyword: simpleNgWordStr });
                console.log('txt===', txt);
              }
            }

            // wow words
            if (res.data.data.wowWords && res.data.data.wowWords.length > 0) {
              for(let i = 0; i < res.data.data.wowWords.length; i++){
                if(res.data.data.wowWords[i]['user_flag'] == 'questioner'){
                  groupNgWord['wow_user'].push(res.data.data.wowWords[i]);
                } else if (res.data.data.wowWords[i]['user_flag'] == 'operator'){
                  groupNgWord['wow_op'].push(res.data.data.wowWords[i]);
                } else if (res.data.data.wowWords[i]['user_flag'] == 'watson_wow'){
                  groupNgWord['wow_watson'].push(res.data.data.wowWords[i]);
                }
              }

              if(groupNgWord['wow_user'].length > 0){
                let strObj = formatWordArr(groupNgWord['wow_user']);
                originWowWordStr = strObj['origin'];
                simpleWowWordStr = strObj['simple'];

                wow_txt = sysInit.state.html_const.cons_255_user_wow.replace('{params}', simpleWowWordStr);
                origin_wow_txt = sysInit.state.html_const.cons_255_user_wow.replace('{params}', originWowWordStr);
              }
              if(groupNgWord['wow_op'].length > 0){
                let strObj = formatWordArr(groupNgWord['wow_op']);
                originWowWordStr = strObj['origin'];
                simpleWowWordStr = strObj['simple'];

                wow_txt = sysInit.state.html_const.cons_256_operator_wow.replace('{params}', simpleWowWordStr);
                origin_wow_txt = sysInit.state.html_const.cons_256_operator_wow.replace('{params}', originWowWordStr);
              }
              if(groupNgWord['wow_watson'].length > 0){
                let strObj = formatWordArr(groupNgWord['wow_watson']);
                originWowWordStr = strObj['origin'];
                simpleWowWordStr = strObj['simple'];
                
                wow_txt = sysInit.state.html_const.cons_262_f2f_wow.replace('{params}', simpleWowWordStr);
                origin_wow_txt = sysInit.state.html_const.cons_262_f2f_wow.replace('{params}', originWowWordStr);
              }
              state.wordList.push({origin: origin_wow_txt, content: wow_txt, type : 'wow', status: '0' , keyword: simpleWowWordStr });
            }

            // warning words
            if (res.data.data.warningWords && res.data.data.warningWords.length > 0) {
              for(let i = 0; i < res.data.data.warningWords.length; i++){
                if(res.data.data.warningWords[i]['user_flag'] == 'questioner'){
                  groupNgWord['warning_user'].push(res.data.data.warningWords[i]);
                } else if (res.data.data.warningWords[i]['user_flag'] == 'operator'){
                  groupNgWord['warning_op'].push(res.data.data.warningWords[i]);
                } else if (res.data.data.warningWords[i]['user_flag'] == 'watson_warning'){
                  groupNgWord['warning_watson'].push(res.data.data.warningWords[i]);
                }
              }

              if(groupNgWord['warning_user'].length > 0){
                let strObj = formatWordArr(groupNgWord['warning_user']);
                originWarningWordStr = strObj['origin'];
                simpleWarningWordStr = strObj['simple'];

                warning_txt = sysInit.state.html_const.cons_332_user_warning.replace('{params}', simpleWarningWordStr);
                origin_warning_txt = sysInit.state.html_const.cons_332_user_warning.replace('{params}', originWarningWordStr);
              }
              if(groupNgWord['warning_op'].length > 0){
                let strObj = formatWordArr(groupNgWord['warning_op']);
                originWarningWordStr = strObj['origin'];
                simpleWarningWordStr = strObj['simple'];

                warning_txt = sysInit.state.html_const.cons_333_operator_warning.replace('{params}', simpleWarningWordStr);
                origin_warning_txt = sysInit.state.html_const.cons_333_operator_warning.replace('{params}', originWarningWordStr);
              }
              if(groupNgWord['warning_watson'].length > 0){
                let strObj = formatWordArr(groupNgWord['warning_watson']);
                originWarningWordStr = strObj['origin'];
                simpleWarningWordStr = strObj['simple'];

                warning_txt = sysInit.state.html_const.cons_334_f2f_warning.replace('{params}', simpleWarningWordStr);
                origin_warning_txt = sysInit.state.html_const.cons_334_f2f_warning.replace('{params}', originWarningWordStr);
              }
              state.wordList.push({origin: origin_warning_txt, content: warning_txt, type : 'warning', status: '0' , keyword: simpleWarningWordStr });
            }

            if(txt.length > 0 || wow_txt.length > 0 || warning_txt.length > 0){
              context.commit("sysInit/changeNavigationText", 'ng/wow:' + new Date().getTime(), { root: true });
            }
          }
      }
    }, (err) => {
      console.log(err);
    })
  },

  fetchKeywordByDialogRight(context, item) {
    item.mode = sysInit.state.personalSingleMode;
    let keywords = state.keywords;
    let keywordCategory = state.keywordCategory;
    api.getKeywordByDialogRight(item).then((res) => {
      if(JSON.stringify(res.data) !="{}"){
          if (res.data.code != 1001) {
            if (res.data.data.d3 != undefined) {
              context.dispatch("echart/echartInit", { type: 'map', data: res.data.data.d3 }, { root: true });
              context.dispatch("echart/echartInit", { type: 'minmap', data: res.data.data.d3 }, { root: true });
            }
            if (res.data.data.d3.nodes && res.data.data.d3.nodes.length > 0) {
              context.commit("discovery/changeMapData", res.data.data.d3, { root: true });
              context.commit("sysInit/changeCurrentKeyword", res.data.data.notesitem, { root: true });
            }

            if (sysInit.state.ws_mode === 'MANUAL_CHAT_MODE') {
              // let keywords = {};
              // let keywordCategory = {};
              // let tempId = sysInit.state.manualChatQuestionerId;
              let tempId = sysInit.state.manualChatModeIssueId;

              if (!state.manualChatKeyWordsObj.hasOwnProperty(tempId)) {

                state.manualChatKeyWordsObj[tempId] = {
                  keywords: {},
                  keywordCategory: {}
                }
              }
              console.log("state.manualChatKeyWordsObj111",state.manualChatKeyWordsObj)
              if (res.data.data.result.length > 0) {
                for (let entity of res.data.data.result) {
                  if (state.manualChatKeyWordsObj[tempId].keywords.hasOwnProperty(entity.value)) {
                    state.manualChatKeyWordsObj[tempId].keywords[entity.value] += 1;
                  } else {
                    state.manualChatKeyWordsObj[tempId].keywordCategory[entity.value] = entity.entity;
                    state.manualChatKeyWordsObj[tempId].keywords[entity.value] = 1;
                  }

                  console.log("state.manualChatKeyWordsObj",state.manualChatKeyWordsObj)


                }
              }
            } else {
              if (res.data.data.result.length > 0) {
                for (let entity of res.data.data.result) {
                  if (keywords.hasOwnProperty(entity.value)) {
                    keywords[entity.value] += 1;
                  } else {
                    keywordCategory[entity.value] = entity.entity;
                    keywords[entity.value] = 1;
                  }
                  context.commit('changeKeywords', { keywordCategory, keywords });

                  // console.log("state.keywords",state.keywords);
                  // console.log("state.keywordCategory",state.keywordCategory);
                }
              }
            }

            let txt = '';
            let origin_txt = '';
            let wow_txt = '';
            let origin_wow_txt = '';
            let groupNgWord = {
              ng_user: [],
              ng_op: [],
              ng_manner: [],
              f2f_ng: [],
              f2f_ng_manner: [],
              wow_user: [],
              wow_op: [],
              wow_watson: [],
              warning_user: [],
              warning_op: [],
              warning_watson: []
            }
            let simpleNgWordStr = '';
            let originNgWordStr = '';
            let simpleNgWordMannerStr = '';
            let originNgWordMannerStr = '';
            let simpleWowWordStr = '';
            let originWowWordStr = '';
            let simpleWarningWordStr = '';
            let originWarningWordStr = '';
            // ng words
            if (res.data.data.ngWords && res.data.data.ngWords.length > 0) {
              for(let i = 0; i < res.data.data.ngWords.length; i++){
                if(res.data.data.ngWords[i]['user_flag'] == 'operator_ngmanner'){
                  groupNgWord['ng_manner'].push(res.data.data.ngWords[i]);
                } else if (res.data.data.ngWords[i]['user_flag'] == 'operator'){
                  groupNgWord['ng_op'].push(res.data.data.ngWords[i]);
                } else if (res.data.data.ngWords[i]['user_flag'] == 'questioner'){
                  groupNgWord['ng_user'].push(res.data.data.ngWords[i]);
                } else if (res.data.data.ngWords[i]['user_flag'] == 'watson_ngmanner'){
                  groupNgWord['f2f_ng_manner'].push(res.data.data.ngWords[i]);
                } else if (res.data.data.ngWords[i]['user_flag'] == 'watson_ng'){
                  groupNgWord['f2f_ng'].push(res.data.data.ngWords[i]);
                }
              }
              
              if(groupNgWord['f2f_ng'].length > 0 || groupNgWord['f2f_ng_manner'].length > 0){
                if(groupNgWord['f2f_ng'].length > 0){
                  let strObj = formatWordArr(groupNgWord['f2f_ng']);
                  originNgWordStr = strObj['origin'];
                  simpleNgWordStr = strObj['simple'];

                  txt = sysInit.state.html_const.cons_262_f2f_ng.replace('{params}', simpleNgWordStr);
                  origin_txt = sysInit.state.html_const.cons_262_f2f_ng.replace('{params}', originNgWordStr);
                }
                if(groupNgWord['f2f_ng_manner'].length > 0){
                  let strObj = formatWordArr(groupNgWord['f2f_ng_manner']);
                  originNgWordMannerStr = strObj['origin'];
                  simpleNgWordMannerStr = strObj['simple'];

                  if(txt.length > 0){
                    txt = txt + '、';
                    origin_txt = origin_txt + '、';
                  }
                  txt += sysInit.state.html_const.cons_263_f2f_ng_manner.replace('{params}', simpleNgWordMannerStr);
                  origin_txt += sysInit.state.html_const.cons_263_f2f_ng_manner.replace('{params}', originNgWordMannerStr);
                }
                console.log('f2f start push++++++',txt, origin_txt );
                state.wordList.push({origin: origin_txt, content: txt, type : 'ng', status: '0' , keyword: simpleNgWordStr });
              }else{
                if(groupNgWord['ng_user'].length > 0 || groupNgWord['ng_op'].length > 0){
                  if(groupNgWord['ng_user'].length > 0){
                    let strObj = formatWordArr(groupNgWord['ng_user']);
                    originNgWordStr = strObj['origin'];
                    simpleNgWordStr = strObj['simple'];

                    txt = sysInit.state.html_const.cons_255_user_ng.replace('{params}', simpleNgWordStr);
                    origin_txt = sysInit.state.html_const.cons_255_user_ng.replace('{params}', originNgWordStr);
                  }else{
                    let strObj = formatWordArr(groupNgWord['ng_op']);
                    originNgWordStr = strObj['origin'];
                    simpleNgWordStr = strObj['simple'];

                    txt = sysInit.state.html_const.cons_256_operator_ng.replace('{params}', simpleNgWordStr);
                    origin_txt = sysInit.state.html_const.cons_256_operator_ng.replace('{params}', originNgWordStr);
                  }
                }
                if(groupNgWord['ng_manner'].length > 0){
                  let strObj = formatWordArr(groupNgWord['ng_manner']);
                  originNgWordMannerStr = strObj['origin'];
                  simpleNgWordMannerStr = strObj['simple'];

                  if(txt.length > 0){
                    txt = txt + '、';
                    origin_txt = origin_txt + '、';
                  }
                  txt += sysInit.state.html_const.cons_257_operator_manner.replace('{params}', simpleNgWordMannerStr);
                  origin_txt += sysInit.state.html_const.cons_257_operator_manner.replace('{params}', originNgWordMannerStr);
                }
                state.wordList.push({origin: origin_txt, content: txt, type : 'ng', status: '0' , keyword: simpleNgWordStr });
                console.log('txt===', txt);
              }
            }

            // wow words
            if (res.data.data.wowWords && res.data.data.wowWords.length > 0) {
              for(let i = 0; i < res.data.data.wowWords.length; i++){
                if(res.data.data.wowWords[i]['user_flag'] == 'questioner'){
                  groupNgWord['wow_user'].push(res.data.data.wowWords[i]);
                } else if (res.data.data.wowWords[i]['user_flag'] == 'operator'){
                  groupNgWord['wow_op'].push(res.data.data.wowWords[i]);
                } else if (res.data.data.wowWords[i]['user_flag'] == 'watson_wow'){
                  groupNgWord['wow_watson'].push(res.data.data.wowWords[i]);
                }
              }

              if(groupNgWord['wow_user'].length > 0){
                let strObj = formatWordArr(groupNgWord['wow_user']);
                originWowWordStr = strObj['origin'];
                simpleWowWordStr = strObj['simple'];

                wow_txt = sysInit.state.html_const.cons_255_user_wow.replace('{params}', simpleWowWordStr);
                origin_wow_txt = sysInit.state.html_const.cons_255_user_wow.replace('{params}', originWowWordStr);
              }
              if(groupNgWord['wow_op'].length > 0){
                let strObj = formatWordArr(groupNgWord['wow_op']);
                originWowWordStr = strObj['origin'];
                simpleWowWordStr = strObj['simple'];

                wow_txt = sysInit.state.html_const.cons_256_operator_wow.replace('{params}', simpleWowWordStr);
                origin_wow_txt = sysInit.state.html_const.cons_256_operator_wow.replace('{params}', originWowWordStr);
              }
              if(groupNgWord['wow_watson'].length > 0){
                let strObj = formatWordArr(groupNgWord['wow_watson']);
                originWowWordStr = strObj['origin'];
                simpleWowWordStr = strObj['simple'];
                
                wow_txt = sysInit.state.html_const.cons_262_f2f_wow.replace('{params}', simpleWowWordStr);
                origin_wow_txt = sysInit.state.html_const.cons_262_f2f_wow.replace('{params}', originWowWordStr);
              }
              state.wordList.push({origin: origin_wow_txt, content: wow_txt, type : 'wow', status: '0' , keyword: simpleWowWordStr });
            }

            // warning words
            if (res.data.data.warningWords && res.data.data.warningWords.length > 0) {
              for(let i = 0; i < res.data.data.warningWords.length; i++){
                if(res.data.data.warningWords[i]['user_flag'] == 'questioner'){
                  groupNgWord['warning_user'].push(res.data.data.warningWords[i]);
                } else if (res.data.data.warningWords[i]['user_flag'] == 'operator'){
                  groupNgWord['warning_op'].push(res.data.data.warningWords[i]);
                } else if (res.data.data.warningWords[i]['user_flag'] == 'watson_warning'){
                  groupNgWord['warning_watson'].push(res.data.data.warningWords[i]);
                }
              }

              if(groupNgWord['warning_user'].length > 0){
                let strObj = formatWordArr(groupNgWord['warning_user']);
                originWarningWordStr = strObj['origin'];
                simpleWarningWordStr = strObj['simple'];

                warning_txt = sysInit.state.html_const.cons_332_user_warning.replace('{params}', simpleWarningWordStr);
                origin_warning_txt = sysInit.state.html_const.cons_332_user_warning.replace('{params}', originWarningWordStr);
              }
              if(groupNgWord['warning_op'].length > 0){
                let strObj = formatWordArr(groupNgWord['warning_op']);
                originWarningWordStr = strObj['origin'];
                simpleWarningWordStr = strObj['simple'];

                warning_txt = sysInit.state.html_const.cons_333_operator_warning.replace('{params}', simpleWarningWordStr);
                origin_warning_txt = sysInit.state.html_const.cons_333_operator_warning.replace('{params}', originWarningWordStr);
              }
              if(groupNgWord['warning_watson'].length > 0){
                let strObj = formatWordArr(groupNgWord['warning_watson']);
                originWarningWordStr = strObj['origin'];
                simpleWarningWordStr = strObj['simple'];

                warning_txt = sysInit.state.html_const.cons_334_f2f_warning.replace('{params}', simpleWarningWordStr);
                origin_warning_txt = sysInit.state.html_const.cons_334_f2f_warning.replace('{params}', originWarningWordStr);
              }
              state.wordList.push({origin: origin_warning_txt, content: warning_txt, type : 'warning', status: '0' , keyword: simpleWarningWordStr });
            }

            if(txt.length > 0 || wow_txt.length > 0 || warning_txt.length > 0){
              context.commit("sysInit/changeNavigationText", 'ng/wow:' + new Date().getTime(), { root: true });
            }
            // // ng words
            // if (res.data.data.ngWords && res.data.data.ngWords.length > 0) {
            //   let ngWords = res.data.data.ngWords.map(v => v.word).join(',');
            //   let ngWordsText = '';
            //   if (res.data.data.ngWords[0].user_flag == 'operator_ngmanner') {
            //     ngWordsText = sysInit.state.html_const.cons_257_operator_manner.replace('{params}', ngWords);
            //   };
            //   if (res.data.data.ngWords[0].user_flag == 'operator') {
            //     ngWordsText = sysInit.state.html_const.cons_256_operator_ng.replace('{params}', ngWords);
            //   };
            //   if (res.data.data.ngWords[0].user_flag == 'questioner') {
            //     ngWordsText = sysInit.state.html_const.cons_255_user_ng.replace('{params}', ngWords);
            //   };
            //   if (res.data.data.ngWords[0].user_flag == 'watson_ng') {
            //     ngWordsText = sysInit.state.html_const.cons_262_f2f_ng.replace('{params}', ngWords);
            //   };
            //   if (res.data.data.ngWords[0].user_flag == 'watson_ngmanner') {
            //     ngWordsText = sysInit.state.html_const.cons_263_f2f_ng_manner.replace('{params}', ngWords);
            //   };
            //   context.commit("sysInit/changeNavigationText", ngWordsText, { root: true });
            //   context.commit("sysInit/changeNgColor", true, { root: true });
            // }

            // // wow words
            // if (res.data.data.wowWords && res.data.data.wowWords.length > 0) {
            //   let wowWords = res.data.data.wowWords.map(v => v.word).join(',');
            //   let wowWordsText = '';
            //   if (res.data.data.wowWords[0].user_flag == 'operator') {
            //     wowWordsText = sysInit.state.html_const.cons_256_operator_wow.replace('{params}', wowWords);
            //   };
            //   if (res.data.data.wowWords[0].user_flag == 'questioner') {
            //     wowWordsText = sysInit.state.html_const.cons_255_user_wow.replace('{params}', wowWords);
            //   };
            //   if (res.data.data.wowWords[0].user_flag == 'watson_ng') {
            //     wowWordsText = sysInit.state.html_const.cons_262_f2f_wow.replace('{params}', wowWords);
            //   };
            //   context.commit("sysInit/changeNavigationText", wowWordsText, { root: true });
            //   context.commit("sysInit/changeWowColor", true, { root: true });
            // }
          }
      }



    }, (err) => {
      console.log(err);
    })
  },
  // updateKeywordByDialog(context, item) {
  //   var data = {
  //     category: state.keywords,
  //     keyword: uniq(values(state.keywordCategory)),
  //     issueId: item.issueId
  //   };
  //   // console.log('updateKeywordByDialog',data)
  //   api.updateKeywordCategroy(data).then((res) => {
  //   }, (err) => {
  //     console.log(err);
  //   })
  // },
  updateKeywordCategroy(context, item) {

    if (sysInit.state.ws_mode === 'MANUAL_CHAT_MODE') {

      var data = {
        category: item.category,
        keyword: item.keyword,
        issueId: item.issueId
      };
      api.updateKeywordCategroy(data).then((res) => {
        console.log(res);
      }, (err) => {
        console.log(err);
      })
    } else {

      var data = {
        category: state.keywords,
        keyword: item.keyword,
        issueId: item.issueId
      };
      api.updateKeywordCategroy(data).then((res) => {
        console.log(res);
      }, (err) => {
        console.log(err);
      })
    }

  },
  updateSubjectByIssueId(context, item) {
    var data = {
      keyword: item.keyword,
      issueId: item.issueId
    };
    api.updateSubjectByIssueId(data).then((res) => {
    }, (err) => {
      console.log(err);
    })
  },
  sttStop(context, item) {
    var data = {
      issue_id: item.issueId,
      mode: sysInit.state.ws_mode,
      login_id:sysInit.state.login_id
    };
    console.log('mode', data);
    api.sttStop(data).then((res) => {
    }, (err) => {
      console.log(err);
    })
  },

  changeOnCallFlag(context, item) {
    api.changeOnCallFlag().then((res) => {
      console.log('change oncallflag success！')
    }, (err) => {
      console.log(err);
    })
  }
  // //wsSttStop
  // wsSttStop(context, item) {
  //   if (sysInit.state.talkStatus === 'end') {
  //     context.dispatch('turnMicOff');
  //   }
  // },
}
const mutations = {
  changeSttNotes(state, sttNotes) {
    state.sttNotes = sttNotes;
    if(state.sttNotes.length>0){
      Vue.set(state.sttNotes, 0, state.sttNotes[0]);
    }
  },
  changeMicStatus(state, micStatus) {
    if (micStatus.hasOwnProperty('isMicOn')) {
      state.isMicOn = micStatus.isMicOn;
    }
    if (micStatus.hasOwnProperty('isMicPause')) {
      state.isMicPause = micStatus.isMicPause;
    }
  },
  changeKeywords(state, keyword) {
    if (keyword.hasOwnProperty('keywords')) {
      state.keywords = keyword.keywords;
    }
    if (keyword.hasOwnProperty('keywordCategory')) {
      state.keywordCategory = keyword.keywordCategory;
    }
  },
}
function removeAudioTrack(){
  console.log('leftStream....',leftStream,leftStream.recognizeStream.options.mediaStream.getAudioTracks())
  // console.log('leftStream R....',leftStream.recognizeStream)
  // let leftTrack = leftStream.recognizeStream.options.mediaStream.getAudioTracks()[0]
  // let rightTrack = rightStream.recognizeStream.options.mediaStream.getAudioTracks()[0]
  if (localAudioStream.getAudioTracks().length>0){
    let leftTrack = localAudioStream.getAudioTracks()[0]
    localAudioStream.removeTrack(leftTrack)
    console.log('left track', leftTrack)
  }
  if(remoteAudioStream.getAudioTracks().length>0){
    let rightTrack = remoteAudioStream.getAudioTracks()[0]
    remoteAudioStream.removeTrack(rightTrack)
    console.log('right track', rightTrack)
  }
  // leftStream.recognizeStream.options.mediaStream.removeTrack(leftTrack)
  // rightStream.recognizeStream.options.mediaStream.removeTrack(rightTrack)
  // localAudioStream.removeTrack(leftTrack)
  // leftStream.recognizeStream.socket.close();
  // rightStream.recognizeStream.socket.close();
  console.log('leftStream2....',leftStream.recognizeStream.options.mediaStream.getAudioTracks())

}

function formatWordArr(arr){
  let str = '';
  let origin = '';
  let len = arr.length > 3 ? 3 : arr.length;
  //origin
  for(let i = 0; i < arr.length; i++){
    if(arr[i]['count'] > 1){
      origin += arr[i]['word'] + "(" + arr[i]['count'] + "回) ,";
    }else{
      origin += arr[i]['word'] + ",";
    }
  }
  //simple
  for(let i = 0; i < len; i++){
    if(arr[i]['count'] > 1){
      str += arr[i]['word'] + "(" + arr[i]['count'] + "回) ,";
    }else{
      str += arr[i]['word'] + ",";
    }
  }
  origin = origin.slice(0, -1);
  str = str.slice(0, -1);;
  str = arr.length > 3 ? str + '...ほか' + arr.length + '語' : str;
  console.log('str=', str);
  return {
    origin: origin,
    simple: str
  }
}


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
